import React from 'react'
import styled from 'styled-components'

const DetailsContainer = styled.div`
  width: 90vw;
  min-height: 100vh;
  padding-left: 2vw;
`

const TitleBanner = styled.div`
  display: flex;
  justify-content: center;
`

const TitleBox = styled.div`
  font-size: 2rem;
  font-family: Montserrat;
  font-weight: bold;
  width: 90vw;
`
export default function AlllocationDetails() {
  return (
    <DetailsContainer>
        <TitleBanner>
          <TitleBox>Details</TitleBox>
        </TitleBanner>

    </DetailsContainer>
  )
}